import type { Query } from '@/gql/graphql'
import { isUndefined, omitBy } from 'lodash'
import { type FC } from 'react'
import { Badge, Card, Col, Row } from 'react-bootstrap'
import styled from 'styled-components'

const Prices = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -40px;
  margin-bottom: 15px;


  @media screen and (min-width:1240px) {
    width: 100%;
    margin-top: -10px;
    height: 100px;
    text-align: center;



    .discount-text{
      margin-top: 10px;
      margin-bottom: -15px;
  }
}

`

const OldPrice = styled.div`
  position:relative;
  display: inline-flex;
  color: #686868;

  .prefix {
    font-size: 10px;
    position: absolute;
    top:5px;
    font-family: inherit;
    font-weight: bold;
  }

  .value {
    font-weight: bold;
  }

  @media screen and (max-width:1240px) {
    height: 20px;
  }


`

const OldPriceMeuMundial = styled.div`
  position:relative;
  display: inline-flex;
  color: #9B9B9B;
  margin-bottom: 5px;

  .prefix {
    font-size: 10px;
    position: absolute;
    top:5px;
    font-family: inherit;
    font-weight: 500;

  }


.value {
  font-weight: bold;
}



.price::after {

}

@media screen and (max-width:1240px) {
  height: 20px;
}


`

const NewPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position:relative;
  margin-top: 15px;
  color: #fe4504;
  font-weight: bold;


  .prefix {
    font-size: 14px;
    position: absolute;
    top:2px;
    left:10px;
    font-family: inherit;
    font-weight: bold;
  }

 .suffix {
  font-size: 11px;
    position: relative;
    top: -20px;
    right: -13px;
    font-family: inherit;
    width: 60px;
    display: flex;
    left: 75px;

 }


 .discount-div{
  width: 60px;
 }

`

const NewPriceMeuMundialNumber = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
position:relative;
margin-top: 5px;
color: #fff;
font-weight: 600;


.prefix {
  font-size: 14px;
  position: absolute;
  top:2px;
  left:0;
  font-family: inherit;
  font-weight: 600;
}

.suffix {
font-size: 11px;
  position: relative;
  top: -20px;
  right: -13px;
  font-family: inherit;
  width: 60px;
  display: flex;
  left: 75px;

}

`
// TODO: transformar em componente separado e colocar as cores em constante
const TagOfertas = styled.div<{ textColor?: string | null, backgroundColor?: string | null }>`
  background-color: ${props => props.backgroundColor ?? '#E5EFF7'};;
  border-radius: 25px;
  height: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 5px;
  color: ${props => props.textColor ?? '#005BAA'};
  padding-left: 30px;
  padding-right: 30px;

  @media screen and (max-width:1240px) {

    /* position: fixed;
    top:15px; */
  }
`

const PricesSale = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 5px;

  p{
      font-weight: 500;
    }

    @media screen and (max-width:1240px) {

    width: 160px;
    text-align: center;
    }

  @media screen and (min-width:1240px) {
    width: 200px;

    p{
      font-size: 12px;
      font-weight: 500;
    }
  }

`


const Price = styled.div`
  text-decoration: none;
  position: relative;
`

const OldReais = styled.span`
  font-family: inherit;
  font-size:23px;
  margin-left:20px;
`

const OldCentavos = styled.sup`
  font-size: 13px;
  vertical-align: initial;
  top: -8px;
`

const Cifrao = styled.span`
  font-size: 15px;
  margin-top: 15px;
  font-family: inherit;
  position:absolute;
  margin-left: 9px;
`

const Reais = styled.span`
  font-family: inherit;
  font-size: 42px;
  margin-left: 40px;

`

const Centavos = styled.sup`
  font-family: inherit;
  font-size:26px;
  margin-left: -7px;
  top: -11px;
`

const OldCifrao = styled.span`
  font-size: 10px;
  margin-top: 8px;
  position:absolute;
`

const NewPriceMeuMundial = styled.div`

  display: flex;
  flex-direction: column;
  border: 1px solid red;
  width: 200px;
  padding: 5px;
  background-color: #EC673C;
  border-radius: 5px;
  text-align:center;


  .legend{
    color:#fff;
    font-size: 9px;
    font-family: inherit;
    stroke-width: 10px;
  }

  .new-price{
    color:#fff;
    font-size: 15px;
    font-family: inherit;
  }

  .line {
    height: 1.2px;
    background-color: #fff;
    width: 120%;
    margin-left: -10%;
    margin-top: 4px;
  }

`

const BoxOldPriceMeuMundial = styled.div`
  position:relative;
  display: inline-flex;
  color: #fff;
  background-color: #A5A4AA;
  width: 120px;
  border-radius: 5px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;

  span.price{
    position: relative;
    width:100px;
    margin-left: 0!important;
  }

  .prefix {
    font-size: 9px;
    position: absolute;
    top: 7px;
    left: 10px;
    font-family: inherit;
    font-weight: bold;
    text-transform: uppercase;
}

 .suffix {
  font-size: 8px;
    position: absolute;
    top: 18px;
    font-family: inherit;
    width: 60px;
    display: flex;
    left: 75px;

 }

  .value {
    font-weight: 600;
  }


@media screen and (max-width:1240px) {
  height: 40px;
}

`

const BoxNewPriceMeuMundial = styled.div`
  position:relative;
  display: inline-flex;
  color: #fff;
  background-color: #47B9DB;
  width: 160px;
  border-radius: 5px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: normal;
  margin-top: 5px;

  span.price{
    position: relative;
    width:145px;
    margin-left: 0!important;
  }

  .prefix {
    font-size: 12px;
    position: absolute;
    top:2px;
    left:10px;
    font-family: inherit;
    font-weight: 500;
    text-transform: uppercase;
  }

 .suffix {
    font-size: 11px;
    position: absolute;
    top: 32px;
    right: -13px;
    font-family: inherit;
    width: 60px;
    display: flex;
    left: 120px;

 }

 span.price {
    margin-left: -15px;
}

  .value {
    font-weight: 600;
  }


@media screen and (max-width:1240px) {
  height: 55px;
}


`
const formatPriceOld = (price: string | null | undefined) => {
  if (!price) {
    return null
  }

  const match = price.match(/(R\$)(?:\s|&nbsp;)?(\d+),(\d+)/)
  if (!match) {
    return <span>Preço inválido</span>
  }

  const [, cifrão, reais, centavos] = match
  return (
    <Price>
      <OldCifrao>{cifrão} </OldCifrao>
      <OldReais>{reais},</OldReais>
      <OldCentavos>{centavos}</OldCentavos>
    </Price>
  )
}

const formatPrice = (price: string | null | undefined) => {
  if (!price) {
    return null
  }

  const match = price.match(/(R\$)(?:\s|&nbsp;)?(\d+),(\d+)/)
  if (!match) {
    return null
  }

  const [, cifrão, reais, centavos] = match
  return (
    <Price>
      <Cifrao>{cifrão} </Cifrao>
      <Reais>{reais},</Reais>
      <Centavos>{centavos}</Centavos>
    </Price>
  )
}

const formatUnit = (description?: string) => {
  if (!description) {
    return 'cada'
  }

  if (description.match(/\b(kg|g)\b/) || description.match(/\b(Kg|g)\b/) || description.match(/\b(KG|g)\b/)) {
    return 'kg'
  }

  if (description.match(/\b(l|litro)\b/)) {
    return 'litro'
  }

  if (description.match(/\b(UN|U)\b/) || description.match(/\bunid\b/)) {
    return 'unidade'
  }

  return 'cada'
}

type CardOffersProductsProps = {
  offer: Partial<Query['offer']>
}

const PriceBlock: FC<CardOffersProductsProps> = ({ offer }) => {
  // 1. Quantity = 1, Quantity2 = 1, Percent = 0
  if (offer.quantity === 1 &&
    (offer.quantity2 === 1 || offer.quantity2 === undefined) &&
    (offer.percent === 0 || offer.percent === undefined)) {

    // id meu mundial ===3
    if (!offer.category || Number(offer.category.id) !== 3) {
      return (
        <>
          {offer.oldPrice !== null && (
            <OldPrice>
              <span className="prefix">de</span>
              <span className="price">
                <span className="value">
                  <span className="number">{formatPriceOld(offer.oldPrice)} </span>
                </span>
              </span>
            </OldPrice>
          )}
          <NewPrice>
            <span className="prefix">por</span>
            <span className="number">{formatPrice(offer.price)}</span>
            <span className="suffix">{formatUnit(offer?.measureUnit ?? undefined)}</span>
          </NewPrice>
          {process.env.NODE_ENV === 'development' && (
            <small>
              <p>1. Quantity = 1, Quantity2 = 1, Percent = 0</p>
            </small>
          )}
        </>
      )
    }

    return (
      <div className='box-price-meu-mundial'>
        {offer.oldPrice !== null && (
          <BoxOldPriceMeuMundial>
            <span className="prefix">de</span>
            <span className="price">
              <span className="value">
                <span className="number">{formatPriceOld(offer.oldPrice)} </span>
                <span className="suffix">{formatUnit(offer.product?.description ?? undefined)}</span>
              </span>
            </span>
          </BoxOldPriceMeuMundial>

        )}

        <BoxNewPriceMeuMundial>
          <span className="prefix">por</span>
          <span className="price">
            <span className="value">
              <span className="number">{formatPrice(offer.price)} </span>
              <span className="suffix">{formatUnit(offer.product?.description ?? undefined)}</span>
            </span>
          </span>

        </BoxNewPriceMeuMundial>

      </div>
    )
  }

  // 2. Quantity = 1, Quantity2 = 1, Percent > 0
  if (offer.quantity === 1 && offer.quantity2 === 1 && (offer?.percent ?? 0) >= 1) {
    return (
      <>
        <Prices>

          <PricesSale className='discount-text' style={{ paddingBottom: 10 }}>
            <p>
              {offer.percent}% de desconto
            </p>
          </PricesSale>
          {offer.oldPrice !== null && (
            <OldPrice>
              <span className="prefix">de</span>
              <span className="price">
                <span className="value">
                  <span className="number">{formatPriceOld(offer.oldPrice)}</span>
                </span>
              </span>
            </OldPrice>
          )}
          <NewPrice>
            <span className="prefix">por</span>
            <span className="number">{formatPrice(offer.price)}</span>
            <span className="suffix">{formatUnit(offer.product?.description ?? undefined)}</span>
          </NewPrice>
        </Prices>
        {process.env.NODE_ENV === 'development' && (
          <small>
            <p>{"2. Quantity = 1, Quantity2 = 1, Percent > 0"}</p>
          </small>
        )}
      </>
    )
  }

  // 3. Quantity > 1, Quantity2 < Quantity, Percent = 0
  if (offer.quantity && offer.quantity >= 2 && (offer?.quantity2 ?? 0) < offer.quantity && (offer?.percent ?? 0) === 0) {
    // id meu mundial ===3
    if (!offer.category || Number(offer.category.id) !== 3) {
      return (
        <>
          <span
            className="suffix"
            style={{
              backgroundColor: '#fff',
              fontSize: 40,
              color: '#E75524',
              fontWeight: 700,
              paddingBottom: 5,
              paddingTop: 5,
              paddingLeft: 5,
              paddingRight: 5,
              borderRadius: 5,
              fontFamily: 'inherit',
              width: 200,
              textAlign: 'center'
            }}
          >
            LEVE {offer.quantity}, PAGUE {offer.quantity2}
          </span>
          {process.env.NODE_ENV === 'development' && (
            <small>
              <p>{"3. Quantity > 1, Quantity2 < Quantity, Percent = 0"}</p>
            </small>
          )}
        </>
      )
    }

    return (
      <div className='box-price-meu-mundial'>
        {offer.oldPrice !== null && (
          <OldPriceMeuMundial>
            <span className="price">
              <span className="value">
                <span className="number">{formatPriceOld(offer.oldPrice)}</span>
              </span>
            </span>
          </OldPriceMeuMundial>
        )}
        <span
          className="discount-div"
          style={{
            backgroundColor: '#fff',
            fontSize: 16,
            color: '#E75524',
            fontWeight: 600,
            paddingBottom: 5,
            paddingLeft: 5,
            paddingRight: 5,
            borderRadius: 5,
            fontFamily: 'inherit',
            width: 120,
            textAlign: 'center'
          }}
        >
          LEVE {offer.quantity}, PAGUE {offer.quantity2}
        </span>
        <NewPriceMeuMundial>
          <span className='legend'>Nesta promoção a unidade sai por</span>
          <div className='line' />
          <NewPriceMeuMundialNumber>
            <span className="number">{formatPrice(offer.price)}</span>
          </NewPriceMeuMundialNumber>
        </NewPriceMeuMundial>
        {/* {process.env.NODE_ENV === 'development' && (
              <small>
                <p>{"4. Quantity > 1, Quantity2 = 1, Percent > 0"}</p>
              </small>
            )} */}
      </div>
    )
  }

  // 4. Quantity > 1, Quantity2 = 1, Percent > 0
  if (offer.quantity && offer.quantity > 1 && offer?.quantity2 === 1 && (offer?.percent ?? 0) >= 1) {
    // id meu mundial ===3
    if (!offer.category || Number(offer.category.id) !== 3) {
      return (
        <>
          <span
            className=""
            style={{
              backgroundColor: '#fff',
              fontSize: 50,
              color: '#E75524',
              fontWeight: 700,
              paddingBottom: 5,
              paddingTop: 5,
              paddingLeft: 5,
              paddingRight: 5,
              borderRadius: 5,
              fontFamily: 'inherit',
              width: 120,
              textAlign: 'center'
            }}
          >
            {offer.percent}%

          </span>
          <span
            className="discount-div"
            style={{
              backgroundColor: '#fff',
              fontSize: 20,
              color: '#E75524',
              fontWeight: 600,
              paddingBottom: 5,
              paddingLeft: 5,
              paddingRight: 5,
              borderRadius: 5,
              fontFamily: 'inherit',
              width: 150,
              textAlign: 'center'
            }}
          >

            de desconto na {offer.quantity}º unidade

          </span>

          {process.env.NODE_ENV === 'development' && (
            <small>
              <p>{"4. Quantity > 1, Quantity2 = 1, Percent > 0"}</p>
            </small>
          )}
        </>
      )
    }

    // é meu mundial
    return (
      <div className='box-price-meu-mundial'>
        {offer.oldPrice !== null && (
          <OldPriceMeuMundial>
            <span className="price">
              <span className="value">
                <span className="number">{formatPriceOld(offer.oldPrice)}</span>
              </span>
            </span>
          </OldPriceMeuMundial>
        )}
        <span
          className="discount-div"
          style={{
            backgroundColor: '#fff',
            fontSize: 16,
            color: '#E75524',
            fontWeight: 600,
            paddingBottom: 5,
            paddingLeft: 5,
            paddingRight: 5,
            borderRadius: 5,
            fontFamily: 'inherit',
            width: 160,
            textAlign: 'center'
          }}
        >
          {offer.percent}% de desconto na {offer.quantity}º unidade
        </span>
        <NewPriceMeuMundial>
          <span className='legend'>Nesta promoção a segunda unidade sai por</span>
          <div className='line' />
          {/* <span className="new-price">{formatPrice(offer.price)}</span> */}
          <NewPriceMeuMundialNumber>
            <span className="number">{formatPrice(offer.price)}</span>
          </NewPriceMeuMundialNumber>
        </NewPriceMeuMundial>
        {/* {process.env.NODE_ENV === 'development' && (
          <small>
            <p>{"4. Quantity > 1, Quantity2 = 1, Percent > 0"}</p>
          </small>
        )} */}

      </div>
    )
  }

  return (
    <p style={{ textAlign: 'center', fontWeight: 'bold', color: '#E75524' }}>
      Não existe um modelo de oferta valido para os parâmetros informados, altere os valores de quantidade e desconto.
    </p>
  )
}

const CardOffersProducts: FC<CardOffersProductsProps> = ({ offer }) => {
  return (
    <Row>
      <Col md={12}>
        <Card
          style={{
            border: '1px solid #E5E5E5',
            borderRadius: 10,
            padding: 10,
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {offer.category && (
            <Card.Header>
              <Badge
                bg='unknown'
                text='unknown'
                style={omitBy({
                  backgroundColor: offer?.category?.customTheme?.backgroundColor ?? undefined,
                  color: offer?.category?.customTheme?.textColor ?? undefined
                }, isUndefined)}
              >
                {offer.category.name ?? ''}
              </Badge>
            </Card.Header>
          )}
          {Object.keys(offer.product ?? {}).length > 0 && (
            <Card.Body>
              <img
                src={offer.product?.images[0]?.url ?? ''}
                width={160}
                height={160}
                alt={offer.product?.description ?? 'Produto'}
                style={{ objectFit: 'contain' }}
              />
            </Card.Body>
          )}
          <div
            className="product-title"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              marginBottom: 10
            }}
          >
            {process.env.NODE_ENV === 'development' && (
              <p
                style={{
                  color: 'var(--ui-colorsLightBlack)',
                  fontSize: 15,
                  fontWeight: 600,
                  margin: 0,
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {offer?.product?.sku ?? ''}
              </p>
            )}
            {offer?.product?.customName && (
              <p
                style={{
                  color: 'var(--ui-colorsLightBlack)',
                  fontSize: 15,
                  fontWeight: 600,
                  margin: 0,
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {offer?.product?.customName}
              </p>
            )}
            <p
              style={{
                fontSize: 15,
                fontWeight: 600,
                margin: 0,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                color: offer.product?.customName?.toLowerCase()?.includes('vinho')
                  ? 'red'
                  : 'black'
              }}
            >
              {offer.product?.customDetail}
            </p>
            <p
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                margin: 0,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {offer.product?.customBrand?.toLocaleUpperCase()}
            </p>
            <p
              style={{
                color: 'var(--ui-colorsLightBlack)',
                fontSize: 15,
                fontWeight: 600,
                margin: 0,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {offer.product?.customType}
            </p>
            <p
              style={{
                color: 'var(--ui-colorsLightBlack)',
                fontSize: 15,
                margin: 0,
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {offer.product?.customWeight}
            </p>
          </div>
          <PriceBlock offer={offer} />
        </Card>
      </Col>
    </Row>
  )
}

export default CardOffersProducts
